const post = (url, data) => {
  return doRequest(url, data, 'post')
}

const get = (url) => {
  return doRequest(url, null, 'get')
}

// 通过实际的url请求
const doRequest = async (url, data, method) => {
  // 请求标识token
  const requestToken = data && data.requestToken
  return new Promise((resolve, reject) => {
    const requestBody = {
      url,
      method: method,
      data,
      success(res) {
        res.requestToken = requestToken
        const success = res && (res.success === true || res.code === '0')
        if (success) {
          res.success = success
          resolve(res)
        } else {
          reject(res)
        }
      },
      error(err) {
        err.requestToken = requestToken
        reject(err)
      }
    }
    if (method === 'post') {
      requestBody.serializer = 'json'
    }
    console.info('requestBody', requestBody)
    window.qing.call('request', requestBody)
  })
}
// 我的收藏列表
export const getFavList = async (data) => post('/msgassist/favorite/list', data)
// 获取分享权限
export const getSharePermission = async (data) => post('/msgassist/favorite/shareRecord', data)
// 删除分享
export const delFavorite = async (data) => post('/msgassist/favorite/delete', data)
// 分享详情
export const getFavoriteDetail = async (data) => post('/msgassist/favorite/get', data)
// 搜索分享
export const searchFavorite = async (data) => post('/msgassist/favorite/search', data)
// 获取用户权限
export const getUserPermission = async (jobNo) => get(`/upm-server/api/permission/getUserPermission?userCode=${jobNo}&type=1&t=${new Date().getTime()}`)


